import { URLS } from 'modules/axios'
import useApi from 'composables/useApi'

export function tiposMateriaisService() {
  const api = useApi()

  function getTiposMateriais(params) {
    return api.query(`${URLS.tiposMateriais}${params || ''}`)
  }

  function getTiposMateriaisById(id) {
    return api.query(`${URLS.tiposMateriais}${id}/`)
  }

  function postTiposMateriais(data) {
    return api.mutation(`${URLS.tiposMateriais}`, 'POST', data)
  }

  function patchTiposMateriais(id, data) {
    return api.mutation(`${URLS.tiposMateriais}${id}/`, 'PATCH', data)
  }

  function deleteTiposMaterial(id) {
    return api.mutation(`${URLS.tiposMateriais}${id}/`, 'DELETE')
  }

  return {
    getTiposMateriais,
    getTiposMateriaisById,
    postTiposMateriais,
    patchTiposMateriais,
    deleteTiposMaterial,
    ...api,
  }
}
